import { inject, Injectable, signal } from '@angular/core';
import { catchError, of, switchMap, tap, Subject } from 'rxjs';
import { CONTEO_SOLICITUDES_PORT, ConteoSolicitudesRespuesta } from '@core/interfaces/conteo-solicitudes-port';

const CONTEO_INICIAL = 0;

@Injectable()
export class BadgeMenuService {
  public readonly conteoSolicitudes = signal(CONTEO_INICIAL);

  private readonly solicitudesService = inject(CONTEO_SOLICITUDES_PORT);
  private readonly cargar$ = new Subject<void>();

  constructor() {
    this.cargar$.pipe(
      switchMap(() => this.solicitudesService.contarPendientes().pipe(
        tap((response: ConteoSolicitudesRespuesta) => this.conteoSolicitudes.set(response.conteo)),
        catchError(() => {
          this.conteoSolicitudes.set(CONTEO_INICIAL);
          return of(null);
        })
      ))
    ).subscribe();
  }

  public cargarConteoSolicitudes(): void {
    this.cargar$.next();
  }

  public invalidar(): void {
    this.cargarConteoSolicitudes();
  }

  public getBadgeCount(ruta: string): number {
    if (ruta === '/plantillas/aprobar') {
      return this.conteoSolicitudes();
    }
    return 0;
  }
}
